<template>
  <div class="container">
    <el-dialog
      width="99%"
      title="历史标签"
      :visible.sync="printInfoDialogVisible"
      center
      @opened="openedPrintDialog"
      @closed="closedPrintDialog">
      <el-form @submit.native.prevent inline :rules="printRules" :model="printForm" ref="refPrintForm">
        <el-form-item label="Tracking NO:">
          <el-input
            ref="refTrayNo"
            autocomplete="off"
            clearable
            maxlength="50"
            v-model.trim="printForm.trayNo"
            @keyup.enter.native="handleEnterTrackingNo"
            @clear="clearTrackingNo"
            tabindex="1">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="loadingPrint"
            type="primary"
            @click="submitPrintForm">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <printInfoListTable
        :data="printInfoList"
        :machineHandNoArray="machineHandNoArray"
        @print="printDetail"
        @updateLabel="updateLabel"
      />
      <pagination
        :total="printCount"
        :pageSize="printPerpage"
        :current-page.sync="printPage"
        @current-change="onChangePrintPage"
      />
    </el-dialog>
    <el-form @submit.native.prevent inline class="form" :rules="rules" :model="form" ref="refForm">
      <el-form-item label="订单子批号：" prop="subNo">
        <subNoInputList
          ref="refSubNo"
          v-model.trim="form.subNo"
          :pageName="pageName"
          @enter="handleEnter"
          style="width: 200px;"
          popoverWidth="200"
        />
      </el-form-item>
      <el-form-item label="数量：" prop="count">
        <el-input
          type="tel"
          ref="refCount"
          clearable
          v-model.number.trim="form.count"
          autocomplete="on"
          maxlength="20"
          style="width: 200px;"
        />
      </el-form-item>
      <el-form-item label="档位:" prop="binLevel">
        <el-select
          filterable
          v-model.trim.number="form.binLevel"
          :disabled="lotNoInfo && lotNoInfo.length >= 1"
          @change="changeBinLevel">
          <el-option
            v-for="(item, i) in passBinLevels"
            :key="i"
            :label="item.explain"
            :value="item.val">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分选机编号:" prop="machineHandNo">
        <el-select
          filterable
          :disabled="lotNoInfo && lotNoInfo.length >= 1"
          v-model.trim="form.machineHandNo"
          style="width: 100%;"
          @change="changeMachineHandNoLevel">
          <el-option
            v-for="(item, i) in machineHandNoArray"
            :key="i"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">
          添加
        </el-button>
      </el-form-item>
    </el-form>
    <el-table :data="lotNoInfo"
              style="margin: 40px auto; width: 80%;"
              :cell-style="{background: '#0E1C3B', 'padding': '5px 5px 5px 0', fontSize: '13px', textAlign: 'center', color: 'white',}"
              :header-cell-style="{background: '#0E1C3B', textAlign: 'center', color: 'white'}">
      <el-table-column width="100">
        <template slot-scope="scope">
          {{scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column
        prop="subNo"
        label="订单子批号">
      </el-table-column>
      <el-table-column
        label="产品型号"
        width="150">
        <template slot-scope="scope">
          {{scope.row.productName && scope.row.chipName ? scope.row.productName + '/' + scope.row.chipName : ''}}
        </template>
      </el-table-column>
      <el-table-column
        prop="partNo"
        label="标签上的PARTNO"
        width="150">
      </el-table-column>
      <el-table-column prop="lotNo" label="印章号"/>
      <el-table-column
        prop="count"
        label="数量"
        width="120">
      </el-table-column>
      <el-table-column
        prop="binLevel"
        label="档位"
        width="80">
      </el-table-column>
      <el-table-column
        prop="machineHandNo"
        label="分选机编号"
        width="120">
      </el-table-column>
      <el-table-column
        prop="endDevicen"
        label="加工完成DeviceNO"
        width="180">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope" width="90">
          <el-button type="text" @click="deleteClick(scope.$index)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center; margin-top: 15px;">
      <el-button
        type="plain"
        @click="getLabel">
        历史标签
      </el-button>
      <el-button
        :loading="loadingMain"
        type="primary"
        @click="printErrorLabel"
        :disabled="lotNoInfo && lotNoInfo.length === 0">
        打印
      </el-button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {generateBinLevelValue, printLabel} from '@/utils/label';
  import {isPositiveIntegerNum, getQueryVariable} from '@/utils';
  import {
    createLabel,
    updateLabel,
    getLabel
  } from '@/api/label';
  import printInfoListTable from './printInfoListTable';
  import subNoInputList from './subNoInputList';
  import pagination from './pagination';
  import { trackingInfo } from '@/api/box';
  import { passBinLevels } from '@/utils/defines';

  export default {
    components: {
      printInfoListTable,
      subNoInputList,
      pagination,
    },
    props: {
      machineHandNoArray: Array,
    },
    data() {
      const validateLotNo = (rule, value, callback) => {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          callback(new Error('印章号不能为空'));
          return false;
        }
        if ((/^\d+$/.test(value))) {
          callback(new Error('印章号不能是纯数字'));
          return false;
        }
        if (!(/^[A-Za-z0-9/$#@-]+$/.test(value))) {
          callback(new Error('印章号格式错误'));
          return false;
        }
        callback();
        return true;
      };
      const validateCount = (rule, value, callback) => {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          callback(new Error('数量不能为空'));
          return false;
        }
        if (!isPositiveIntegerNum(value)) {
          callback(new Error('数量必须是正整数'));
          return false;
        }
        callback();
        return true;
      };
      let validateTrackingNo = (rule, value, callback) => {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          callback();
          return;
        }
        if (!(/^[A-Za-z0-9/$#@-]+$/.test(value))) {
          callback(new Error(`Tracking NO格式错误`));
          return;
        }
        callback();
      };
      return {
        rules: {
          lotNo: [{required: true, validator: validateLotNo, trigger: 'submit'}],
          subNo: [{required: true, message: '请输入订单子批号', trigger: 'submit'}],
          count: [{required: true, validator: validateCount, trigger: 'submit'}],
          binLevel: [{required: true, message: '请选择档位', trigger: 'submit'}],
          machineHandNo: [{required: true, message: '请选择分选机编号', trigger: 'submit'}],
        },
        form: {
          subNo: undefined,
          count: undefined,
          binLevel: 1,
          machineHandNo: undefined,
        },
        printRules: {
          trayNo: [{required: true, validator: validateTrackingNo, trigger: 'submit'}],
        },
        printForm: {
          trayNo: undefined,
        },
        searchParams: {
          trayNo: undefined,
        },
        loadingPrint: false,

        lotNoInfo: [],
        loadingMain: false,
        isRequestOrder: false,

        printInfoList: [],
        printInfoDialogVisible: false,
        printPage: 1,
        printPerpage: 20,
        printCount: 0,
        pageName: 'mixedLabelPrint',
        passBinLevels,
      }
    },
    watch: {
      $route: {
        handler() {
          this.queryMachineHandNo({isRouterChange: true});
        },
      },
    },
    mounted() {
      const {
        machineHandNoArray,
        pageName,
      } = this;
      let defaultMachineHandNo = machineHandNoArray && machineHandNoArray.length > 0 ? machineHandNoArray[0] : undefined;
      this.form.binLevel = this.binLevelObj[pageName] || 1;
      this.form.machineHandNo = this.machineHandNoObj[pageName] || defaultMachineHandNo;
      this.$refs.refSubNo && this.$refs.refSubNo.focus();
      this.scanBoxInfoBarCode();
      this.queryMachineHandNo();
    },
    computed: {
      ...mapGetters([
        'labelPrintCountObj',
        'subNoListObj',
        'binLevelObj',
        'machineHandNoObj',
        'queryMachineHandNoUsedObj',
      ]),
    },
    methods: {
      queryMachineHandNo({isRouterChange = false} = {}) {
        const {
          queryMachineHandNoUsedObj,
          pageName,
          machineHandNoArray,
        } = this;
        const machineHandNo = getQueryVariable('machineHandNo');
        if (machineHandNo && machineHandNoArray) {
          if (machineHandNoArray.includes(machineHandNo)) {
            if (!queryMachineHandNoUsedObj[pageName] || isRouterChange) {
              this.form.machineHandNo = machineHandNo;
              this.queryMachineHandNoUsedObj[pageName] = true;
              this.$store.commit('label/saveQueryMachineHandNoUsedObj', this.queryMachineHandNoUsedObj);
              this.machineHandNoObj[pageName] = machineHandNo;
              this.$store.commit('label/saveMachineHandNoObj', this.machineHandNoObj);
            }
          }
        }
      },
      scanBoxInfoBarCode() {
        let code = '';
        let nextCode;
        document.onkeypress = (e) => {
          nextCode = e.which;
          if (nextCode !== 13) {
            code += String.fromCharCode(nextCode);
          }
          if (nextCode === 13) {
            if (this.printInfoDialogVisible) {
              if (this.loadingPrint) {
              } else if (this.$refs.refTrayNo && this.$refs.refTrayNo.focused) {
              } else {
                this.printForm.trayNo = code;
                this.submitPrintForm();
              }
            } else if (this.loadingMain) {
            } else if (this.$refs.refSubNo && this.$refs.refSubNo.focused) {
              if (this.form.count) {
              } else {
                this.$refs.refCount && this.$refs.refCount.focus();
              }
            } else if (this.$refs.refCount && this.$refs.refCount.focused) {
            } else {
              this.form.subNo = code;
              if (this.form.count) {
                this.submitForm();
              } else {
                this.$refs.refCount && this.$refs.refCount.focus();
              }
            }
            code = '';
          }
        };
      },
      deleteClick(index) {
        this.lotNoInfo.splice(index, 1);
      },
      handleEnterTrackingNo() {
        this.submitPrintForm();
      },
      clearTrackingNo() {
        this.submitPrintForm();
      },
      submitPrintForm() {
        this.$refs.refPrintForm.validate(async (valid) => {
          if (valid) {
            this.printPage = 1;
            this.searchParams = {...this.printForm};
            this.getLabel();
          }
        });
      },
      handleEnter() {
        this.submitForm();
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            this.addErrorLotInfo();
          }
        });
      },
      async addErrorLotInfo() {
        const {
          subNo,
          count,
          binLevel,
          machineHandNo,
        } = this.form;
        this.form.subNo = '';
        this.form.count = '';
        let findIndex = this.lotNoInfo.findIndex(item => item.subNo === subNo);
        if (findIndex === -1) {
          let findBinLevelIndex = this.lotNoInfo.findIndex(item => item.binLevel !== binLevel);
          if (findBinLevelIndex !== -1) {
            this.$message({
              message: '不同档位的芯片不能混装',
              type: 'error'
            });
            return;
          }
          try {
            const res = await trackingInfo({subNo});
            const data = res.data;
            const {
              lotNo,
              productName,
              chipName,
              partNo,
              isMixed,
              id,
              endDevicen,
            } = data;
            if (isMixed === 0) {
              this.$message({
                message: '该订单子批号不允许混装',
                type: 'error'
              });
              return;
            }
            let findProdNoIndex = this.lotNoInfo.findIndex(item => item.productName !== productName || item.chipName !== chipName || item.partNo !== partNo);
            if (findProdNoIndex !== -1) {
              this.$message({
                message: '不同产品型号芯片不能混装',
                type: 'error'
              });
              return;
            }
            let targetMaterial;
            let isDiffTargetMaterial = false; // 加工完成DeviceNO(如LS9931CS/AS/E/C/G) C表示靶材，不同的靶材希望加上提示，提示是否要混编
            if (/[A-Z]\/[A-Z]$/.test(endDevicen)) {
              let splitArray = endDevicen.split('/');
              targetMaterial = splitArray[splitArray.length - 2]
              for (let row of this.lotNoInfo) {
                if (/[A-Z]\/[A-Z]$/.test(row.endDevicen)) {
                  splitArray = row.endDevicen.split('/');
                  if (targetMaterial !== splitArray[splitArray.length - 2]) {
                    isDiffTargetMaterial = true;
                  }
                }
              }
            }
            if (isDiffTargetMaterial) {
              this.$confirm(`订单子批号 ${subNo} 的加工完成DeviceNO ${endDevicen} 中的靶材${targetMaterial}和已经添加的其他订单子批号的靶材存在不同，是否继续添加？`, this.$t('remindInfo.warning'), {
                confirmButtonText: this.$t('remindInfo.confirm'),
                cancelButtonText: this.$t('remindInfo.cancel'),
                type: 'warning',
              }).then(async () => {
                this.lotNoInfo.push({
                  incoOrdersDetailId: id,
                  subNo,
                  count: Number.parseInt(count, 10),
                  lotNo,
                  productName,
                  chipName,
                  partNo,
                  binLevel,
                  machineHandNo,
                  endDevicen,
                });
                this.saveSubNoInputList(subNo);
              }).catch(() => {
                // do nothing.
              });
            } else {
              this.lotNoInfo.push({
                incoOrdersDetailId: id,
                subNo,
                count: Number.parseInt(count, 10),
                lotNo,
                productName,
                chipName,
                partNo,
                binLevel,
                machineHandNo,
                endDevicen,
              });
              this.saveSubNoInputList(subNo);
            }
          } catch (e) {
          }
        } else {
          this.$message({
            message: '订单子批号重复',
            type: 'error'
          });
        }
      },
      saveSubNoInputList(subNo) {
        const subNoListObj = this.subNoListObj;
        const pageName = this.pageName;
        const subNoList = subNoListObj[pageName] || [];
        const findIndex = subNoList.findIndex(item => item === subNo);
        if (findIndex === -1) {
          subNoList.unshift(subNo)
        }
        const isMoreThan9 = subNoList && subNoList.length > 9;
        if (isMoreThan9) {
          subNoList.pop();
        }
        subNoListObj[pageName] = subNoList;
        this.$store.commit('label/saveSubNoListObj', {...subNoListObj});
      },
      async printErrorLabel() {
        const lotNoInfo = this.lotNoInfo;
        this.loadingMain = true;
        let binLevel, machineHandNo, productName, chipName;
        const info = lotNoInfo.map(item => {
          binLevel = item.binLevel;
          productName = item.productName;
          chipName = item.chipName;
          if (machineHandNo === undefined) {
            machineHandNo = item.machineHandNo;
          }
          return {
            incoOrdersDetailId: item.incoOrdersDetailId,
            count: Number.parseInt(item.count, 10),
          };
        });
        try {
          const res = await createLabel({
            lotNoInfo: JSON.stringify(info),
            binLevel: binLevel !== undefined ? Number.parseInt(binLevel, 10) : undefined,
            machineHandNo,
          });
          const data = res.data;
          this.form.subNo = '';
          this.lotNoInfo = [];
          let binLevelValue = generateBinLevelValue({productName, chipName, binLevel});
          printLabel({...data, binLevelExplain: binLevelValue});
        } catch (e) {
        } finally {
          this.loadingMain = false;
        }
      },
      printDetail(labelData) {
        printLabel(labelData);
      },
      async getLabel() {
        this.loadingPrint = true;
        try {
          const res = await getLabel({
            page: this.printPage,
            perpage: this.printPerpage,
            result: true,
            keyword: this.searchParams.trayNo || undefined,
          });
          const data = res.data;
          this.printInfoDialogVisible = true;
          this.printInfoList = data.info;
          if (data.count !== undefined) {
            this.printCount = data.count;
          }
        } catch (e) {
        } finally {
          this.loadingPrint = false;
        }
      },
      async onChangePrintPage() {
        this.getLabel();
      },
      async updateLabel({id, partNo, partNoSuffix, trackingNo, dateCode, lotNoInfo, binLevel, machineHandNo = undefined}) {
        try {
          await updateLabel({
            labelId: id,
            partNo: partNo + partNoSuffix,
            trackingNo,
            dateCode,
            lotNoInfo: JSON.stringify(lotNoInfo),
            binLevel: Number.parseInt(binLevel, 10),
            machineHandNo: machineHandNo,
          });
          this.$message({
            type: 'success',
            message: '更新成功',
          });
        } catch (e) {
        } finally {
          this.getLabel();
        }
      },
      changeBinLevel(val) {
        const pageName = this.pageName;
        this.binLevelObj[pageName] = Number.parseInt(val, 10);
        this.$store.commit('label/saveBinLevelObj', this.binLevelObj);
      },
      changeMachineHandNoLevel(val) {
        const pageName = this.pageName;
        this.machineHandNoObj[pageName] = val;
        this.$store.commit('label/saveMachineHandNoObj', this.machineHandNoObj);
      },
      openedPrintDialog() {
        this.$refs.refTrayNo && this.$refs.refTrayNo.focus();
      },
      closedPrintDialog() {
        this.printForm.trayNo = undefined;
        this.$refs.refPrintForm && this.$refs.refPrintForm.clearValidate();
        this.$refs.refSubNo && this.$refs.refSubNo.focus();
      }
    }
  };
</script>
<style lang="less" scoped>
  .container {
    font-size: 12px;
    height: 100%;
    overflow: auto;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form {
    margin-top: 40px;
    display: inline-block;
  }

  .lotNoInfoContainer {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
  }

  .link {
    color: rgba(49, 128, 253, 0.65);
    margin: 0 13px;
    height: 40px;
  }
</style>
